import React from 'react';
import bemBlock, { useBemCN } from '@gik/core/utils/bemBlock';
import { Avatar, CopyEmailButtonCircle, ExternalLink, UI } from '@gik/ui';
import { BaseUserWithAvatar } from '@gik/core/models/gik/User';

export interface IUserInfoModalContentProps {
  user: BaseUserWithAvatar;
}

const blockName = 'user-info-modal';

export function UserInfoModalContent({ user }: IUserInfoModalContentProps) {
  const bem = useBemCN(blockName);

  return (
    <section {...bem('content')}>
      <Avatar imageUrl={user.avatarURL} size={'2xl'} />
      <h1 {...bem('user-name')}>{`${user.firstName} ${user.lastName}`.trim()}</h1>
      <ExternalLink href={`mailto:${user.emailAddress}`} {...bem('user-email-address')}>
        {user.emailAddress}
      </ExternalLink>
      <CopyEmailButtonCircle textToCopy={user.emailAddress} {...bem('copy-button')} />
    </section>
  );
}

export function openUserInfoModal(user: BaseUserWithAvatar) {
  const bem = bemBlock(blockName);
  return UI.dialog(<UserInfoModalContent user={user} />, {
    className: bem(),
    closable: true,
    modalProps: {
      shouldCloseOnOverlayClick: true,
    },
  });
}
